/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useOrgId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let orgId = urlParams.get("orgid");

  if (orgId) {
    orgId = String(orgId).trim();
  }

  return {
    orgId,
  };
};
